import myaxios from '@/myaxios.js'
const state = {
    allEnum: {}
}

const mutations = {
    SET_ALL_ENUM: (state, allEnum) => {
        state.allEnum = allEnum
    }

}

const actions = {
    ADD_ALL_ENUM: function({ state, commit, getters }) {
        if (!_.isEmpty(state.allEnum)) return
        console.log(`load  sys_enums`)
        return new Promise(resolve => {
            myaxios.get(`/api/AcisSystem/SystemServer/GetEnums`).then((data) => {
                let r = _.groupBy(data, `code`)
                _.each(r, d => {
                    _.each(d, i => {
                        i.code = i.description
                    })
                })
                console.log(`ADD_ALL_ENUMADD_ALL_ENUMADD_ALL_ENUMADD_ALL_ENUMADD_ALL_ENUM`, r)
                commit(`SET_ALL_ENUM`, r)
                resolve(r)
            }).catch(error => {
                console.log(error)
            })
        })
    }
}

const getters = {
    all_enum: (state, getters) => {
        return state.allEnum
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/enums.js